/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TypographyChatActivityCount_EmbedQuery = {
    readonly chatActivityCount: number | null;
    readonly " $refType": "TypographyChatActivityCount_EmbedQuery";
};
export type TypographyChatActivityCount_EmbedQuery$data = TypographyChatActivityCount_EmbedQuery;
export type TypographyChatActivityCount_EmbedQuery$key = {
    readonly " $data"?: TypographyChatActivityCount_EmbedQuery$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyChatActivityCount_EmbedQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyChatActivityCount_EmbedQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        }
      ],
      "kind": "ScalarField",
      "name": "chatActivityCount",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '6295372b9e713f62154eb71827b140f9';
export default node;
